module.exports = __webpack_public_path__ + "img/bg.b8fd2db5.png";